import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderComponent, renderNothing } from 'recompose';
import { Table } from 'react-bootstrap';

import jobInvoiceableDeferredInbox from '../graphql/jobInvoiceableDeferredInbox';
import { selectJobId } from '../actions';
import { handleRowColor } from '../utils';

const nodeType = PropTypes.shape({
  id: PropTypes.number,
});


const propTypes = exact({
  jobs: PropTypes.arrayOf(nodeType).isRequired,
  selectedJobId: PropTypes.number.isRequired,
  selectJobIdAction: PropTypes.func.isRequired,
});


const DeferredJobInbox = (props) => {
  const { selectedJobId, selectJobIdAction } = props;

  const renderJobRow = (deferredJob) => {
    const {
      id,
      month_lease_invoice,
      lease,
      ticket_count,
      invoice_state,
      accountingState,
    } = deferredJob;


    const {
      name: leaseName,
      operator: {
        name: operatorName,
      },
    } = lease;
    const listDate = month_lease_invoice.date.display;
    const isActive = id === selectedJobId;
    const handleClick = () => { selectJobIdAction(id); };
    const invoicableStateColor = handleRowColor(invoice_state, isActive, accountingState);
    /* eslint-disable camelcase */
    return (
      <tr
        style={{ backgroundColor: invoicableStateColor }}
        key={id}
        // eslint-disable-next-line react/no-unknown-property
        subject={id}
        onClick={handleClick}
      >
        <td>{listDate}</td>
        <td>{operatorName}</td>
        <td>{leaseName}</td>
        <td>{ticket_count}</td>
      </tr>
    );
    /* eslint-enable camelcase */
  };

  const { jobs } = props;
  return (
    <div style={{ maxHeight: '64vh', overflowY: 'auto', overflowX: 'hidden' }}>
      <Table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Operator</th>
            <th>Lease</th>
            <th>Ticket Count</th>
          </tr>
        </thead>
        <tbody>{jobs.map(renderJobRow, this)}</tbody>
      </Table>
    </div>
  );
};


DeferredJobInbox.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    selectedJobId: state.ticketInvoicing.jobId,
  };
};


const mapDispatchToProps = {
  selectJobIdAction: selectJobId,
};


const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withHide = branch(
  (props) => { return props.selectedJobId === null; },
  renderNothing,
);


/*
* NOTE: This empty component depends on its parent being a panel.
* I'm not how to handle these HTML "dependencies" this at the moment.
*/
const withNoDeferredJobs = branch(
  (props) => { return props.jobs.length === 0; },
  renderComponent((props) => {
    return (
      <div className="panel-body" style={{ textAlign: 'center' }}>
        <h4>Empty</h4>
        <p className="text-muted">No Deferred Jobs are available for invoicing</p>
      </div>
    );
  }),
);


const withSelectFirstDeferredJob = lifecycle({
  componentWillMount() {
    const { jobs, selectJobIdAction } = this.props;
    if (jobs.length > 0) {
      selectJobIdAction(jobs[0].id);
    }
  },
});


const enhance = compose(
  jobInvoiceableDeferredInbox,
  withNoDeferredJobs,
  withRedux,
  withSelectFirstDeferredJob,
  withHide,
);


export default enhance(DeferredJobInbox);
